import EmployeeSchedule from "./EmployeeSchedule/EmployeeSchedule.vue";
import PatientSchedule from "./PatientSchedule/PatientSchedule.vue";
import ReportCenter from "./ReportCenter/ReportCenter.vue";

const routes = [
    {
        path: "/axxess-central/reports",
        component: ReportCenter,
        name: "report-center",
        meta: {
            menuName: "Report Center",
            navItem: "tabEmployeeSchedule",
            showAxxessCentral: true
        }
    },
    {
        path: "/axxess-central/reports/employee-schedule",
        component: EmployeeSchedule,
        name: "employee-schedule",
        meta: {
            menuName: "Employee Schedule",
            navItem: "tabEmployeeSchedule",
            showAxxessCentral: true,
            showInLevelTwoNav: false
        }
    },
    {
        path: "/axxess-central/reports/patient-schedule",
        component: PatientSchedule,
        name: "patient-schedule",
        meta: {
            menuName: "Patient Schedule",
            navItem: "tabPatientSchedule",
            showAxxessCentral: true,
            showInLevelTwoNav: false
        }
    }
];
export default routes;
